import React, { Component } from 'react'
import { NewTerrain, printMapToCanvas } from '../../utils/map-generator'

export default class TerrainGenerator extends Component {
  constructor(props) {
    super(props)
    this.canvas = {
      width: 1024,
      height: 768,
    }
    this.size = {
      x: 1024,
      y: 768,
      z: 1,
    }
    this._initializeTerrain()
  }

  _initializeTerrain() {
    this.terrain = new NewTerrain({
      size: this.size,
      zoom: 100,
      seed: 'tanner',
    })
  }

  componentDidMount() {
    printMapToCanvas({
      size: this.size,
      map: this.terrain.terrain,
      canvas: this.refs.canvas,
    })
  }

  render() {
    return (
      <div>
        <canvas ref="canvas" width={this.canvas.width} height={this.canvas.height} />
      </div>
    )
  }
}
